import { useTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { TState } from 'redux/config/root-types'
import { Actions_CurrentStaffMember } from 'redux/modules/currentStaffMember/Actions'
import { Actions_Modals } from 'redux/modules/modals/Actions'
import { To } from 'router/To'
import { I18nModal } from 'utils/i18n/i18nModal'

export const useStaffDelete = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation(I18nModal.staffDelete)
  const navigate = useNavigate()

  const staffId = useSelector(({ modals }: TState) => modals.data.id)

  const onSubmit = () => {
    const navigateToStaffTable = () => navigate(To.staff)
    dispatch(Actions_CurrentStaffMember.saga.deleteStaff({ id: staffId, navigateToStaffTable }))
    dispatch(Actions_Modals.store.hideModal())
  }

  const onCancel = () => dispatch(Actions_Modals.store.hideModal())

  return { t, onSubmit, onCancel }
}
